function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTransparent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 364.775,
    height: 383.178,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2409.608 4304.625c122.66 33.99 254.65-12.9 328.43-116.68 55.57-78.15 70.69-175.74 41.5-267.73-.64-2.01-1.08-4.08-1.33-6.17l-3.84-32.99c-29.71-253.6 135.02-490.75 383.17-551.64l46.62-11.43c2.87-.97 5.9-1.53 9.02-1.66 94.69-3.99 180.29-50.31 234.86-127.05 46.97-66.08 65.4-146.48 51.9-226.4-13.5-79.93-57.33-149.82-123.39-196.78-28.98-20.6-60.86-35.81-94.76-45.21-122.65-33.99-254.63 12.91-328.41 116.69-54.58 76.76-70.2 172.83-42.87 263.57.92 3.03 1.38 6.11 1.41 9.17l4.5 47.69c24.03 254.37-145.85 487.87-395.14 543.14l-32.43 7.18c-2.04.45-4.14.72-6.24.77-96.48 2.66-183.67 49-239.24 127.16-96.96 136.37-64.88 326.2 71.5 423.18 28.96 20.59 60.84 35.79 94.73 45.18l.01.01",
    style: {
      fill: "#fbbc09",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 -212.136 585.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3867.448 2910.525c159.5 44.2 322.47-45.2 371.02-203.52 49.07-159.98-41.17-330.05-201.15-379.12l-8.04-2.35c-89.18-24.71-183.62-7.48-259.13 47.29-1.7 1.25-3.51 2.31-5.42 3.2l-30.09 14.06c-108.56 50.71-232.74 60.8-349.65 28.4-122.93-34.06-227.57-111.6-294.62-218.31l-25.49-40.58a32.441 32.441 0 0 1-4.47-8.12c-33.61-88.59-104.52-155.26-194.56-182.87l-8.09-2.36c-159.5-44.2-322.47 45.2-371.02 203.52-23.78 77.5-15.94 159.62 22.06 231.22 37.98 71.62 101.58 124.13 179.07 147.9l8.07 2.35c87.56 24.27 180.72 7.97 255.58-44.7 2.6-1.83 5.41-3.26 8.32-4.24l43.79-19.28c106.03-46.66 226.59-55.13 339.49-23.84 127.02 35.2 233.74 116.1 300.47 227.8l17.03 28.47c1.08 1.81 1.98 3.71 2.7 5.7 32.91 90.72 104.37 158.89 196.05 187.02l8.08 2.36",
    style: {
      fill: "#db1d27",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 -212.136 585.41)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2250.998 3358.435c55.86 15.47 114.8 14.55 170.46-2.68 159.86-49.46 249.66-219.75 200.2-379.61-27.84-89.98-94.68-160.73-183.37-194.11a33.041 33.041 0 0 1-8.19-4.5l-40.56-25.34c-216.7-135.4-299.03-412.18-191.53-643.8l13.98-30.12c.88-1.89 1.94-3.71 3.18-5.42 56.48-78.26 72.62-175.69 44.27-267.28-30.71-99.25-108.9-175.08-209.16-202.87-55.85-15.48-114.8-14.56-170.46 2.66-159.86 49.48-249.67 219.77-200.2 379.62 28.34 91.61 96.67 162.88 187.49 195.56 1.98.72 3.89 1.62 5.7 2.7l28.55 16.98c219.52 130.41 307.89 405.31 205.56 639.43l-19.19 43.88a33.13 33.13 0 0 1-4.2 8.28c-54.34 77.65-69.53 173.77-41.69 263.75 30.71 99.23 108.9 175.08 209.16 202.87",
    style: {
      fill: "#5aa2dd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(.13333 0 0 -.13333 -212.136 585.41)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTransparent);
export default __webpack_public_path__ + "static/media/logo_transparent.9fb39105e1b57f48771f8cd8d7a742e5.svg";
export { ForwardRef as ReactComponent };